import React from "react";
import * as Mui from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  designColors,
  designShell,
  FORM_ACTION_BUTTON_WIDTH,
} from "services/constants/designTokens";

// Primary/secondary action buttons for the teal/slate design system
// introduced for the Administration redesign (see designTokens.js).
// CustomButton/CustomButtonWithBorder in this same folder are the older,
// app-wide button pair (mint-green fill, plain MUI-blue outline) and stay
// untouched here deliberately — recoloring them would silently reskin
// every not-yet-redesigned screen that still renders them. Any screen that
// has already opted into the teal design system (has a
// `<ThemeProvider theme={designTheme}>` around it) should reach for these
// instead, so the look lives in one place rather than being hand-copied
// per screen. First shared consumer: Administration/CreateUser.
export const PrimaryButton = ({ children, sx, ...props }) => (
  <LoadingButton
    variant="contained"
    sx={{
      ...designShell.primaryButtonBase,
      minWidth: FORM_ACTION_BUTTON_WIDTH,
      ...sx,
    }}
    {...props}
  >
    {children}
  </LoadingButton>
);

export const SecondaryButton = ({ children, sx, ...props }) => (
  <Mui.Button
    variant="outlined"
    sx={{
      minHeight: 46,
      minWidth: FORM_ACTION_BUTTON_WIDTH,
      px: 2.5,
      borderRadius: "8px",
      textTransform: "none",
      fontSize: 14,
      fontWeight: 600,
      color: designColors.slate700,
      borderColor: designColors.slate300,
      "&:hover": {
        borderColor: designColors.tealDark,
        backgroundColor: designColors.tealTint,
        color: designColors.tealDark,
      },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Mui.Button>
);

export const PanelActionFooter = ({
  onCancel,
  cancelLabel = "Cancel",
  primaryLabel = "Create",
  primaryProps = {},
}) => (
  <Mui.Stack
    direction={{ xs: "column-reverse", sm: "row" }}
    spacing={1.5}
    justifyContent="flex-end"
    sx={{ width: "100%" }}
  >
    <SecondaryButton onClick={onCancel}>{cancelLabel}</SecondaryButton>
    <PrimaryButton {...primaryProps}>{primaryLabel}</PrimaryButton>
  </Mui.Stack>
);
